import Validator from "validatorjs";
import moment from "moment";

let registered = false;

const CustomValidators = () => {
  if (registered) return;

  Validator.register(
    "validDate",
    (value: any) => {
      if (!value) return true;

      const selected = moment.isMoment(value)
        ? value.clone()
        : moment(value, ["DD/MM/YYYY", moment.ISO_8601], true);

      return selected.isValid();
    },
    "Invalid date",
  );

  Validator.register(
    "minDateValidator",
    (value: any) => {
      if (!value) return true;

      const selected = moment.isMoment(value)
        ? value.clone()
        : moment(value, ["DD/MM/YYYY", moment.ISO_8601], true);

      if (!selected.isValid()) return true;

      return !selected.isBefore(moment().startOf("day"), "day");
    },
    "Past dates are not allowed.",
  );

  registered = true;
};

export default CustomValidators;
